import api from '@/libs/api';
import { DisbursementBalanceResponse } from '@/libs/api.interfaces';
import {
  MutationTree, Module, ActionContext, ActionTree,
} from 'vuex';
import { RootState } from './types';

export type State = {
  loading: boolean;
  total: number;
  active: number;
  pending: number;
}

export enum MutationTypes {
  SET_DISBURSEMENT_BALANCE_LOADING = 'SET_DISBURSEMENT_BALANCE_LOADING',
  SET_DISBURSEMENT_BALANCE = 'SET_DISBURSEMENT_BALANCE',
}

const states: State = {
  loading: true,
  total: 0,
  active: 0,
  pending: 0,
};

export type Mutations<S = State> = {
  [MutationTypes.SET_DISBURSEMENT_BALANCE_LOADING](state: S, payload: boolean): void;
  [MutationTypes.SET_DISBURSEMENT_BALANCE](state: S, payload: {
    total: number;
    active: number;
    pending: number;
  }): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_DISBURSEMENT_BALANCE_LOADING](state, payload) {
    state.loading = payload;
  },
  [MutationTypes.SET_DISBURSEMENT_BALANCE](state, { total, pending, active }) {
    state.total = total;
    state.pending = pending;
    state.active = active;
  },
};

export enum ActionTypes {
  GET_DISBURSEMENT_BALANCE = 'GET_DISBURSEMENT_BALANCE',
}

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ActionTypes.GET_DISBURSEMENT_BALANCE](
    { commit }: AugmentedActionContext,
    payload: void
  ): Promise<void>;
}

export const actions: ActionTree<State, RootState> & Actions = {
  // eslint-disable-next-line @typescript-eslint/camelcase
  async [ActionTypes.GET_DISBURSEMENT_BALANCE]({ commit }, merchant_code) {
    try {
      commit(MutationTypes.SET_DISBURSEMENT_BALANCE_LOADING, true);
      const { data } = await api.get<DisbursementBalanceResponse>('/disbursement/balance', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_code,
        },
      });
      commit(MutationTypes.SET_DISBURSEMENT_BALANCE, {
        total: data.data.balance.total,
        pending: data.data.balance.pending,
        active: data.data.balance.active,
      });
      commit(MutationTypes.SET_DISBURSEMENT_BALANCE_LOADING, false);
    } catch (err) {
      console.log(err);
    }
  },
};

const disbursementModule: Module<State, RootState> = {
  state: states,
  mutations,
  actions,
};

export default disbursementModule;
